import { FC } from 'react';
import { FeedView } from './feed-view';

export const FeedPanel: FC = () => (
  <div className="pt-7">
    <FeedView />
  </div>
);
